<block-ui name="main" >
    <router-outlet></router-outlet>
</block-ui>

<div #modalContainer ></div>
